import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { Select, MenuItem } from "@mui/material";
import { syncDayjsLocale } from './date_picker/dateUtils';

export default function ChangeLanguage() {
  const { i18n } = useTranslation();

  const changeLanguage = (e) => {
    const lang = e.target.value;
    i18n.changeLanguage(lang);
    syncDayjsLocale(lang)
    localStorage.setItem("lang", lang);

    localStorage.setItem("last_env_lang", process.env.REACT_APP_LANGUAGE);
  };

  return (
    <Select
      size="small"
      value={i18n.language}
      onChange={(e) => changeLanguage(e)}
    >
      <MenuItem value="ko">한국어</MenuItem>
      <MenuItem value="en">English</MenuItem>
      <MenuItem value="zh-CN">中文</MenuItem>
    </Select>
  );
}
